import { createAsyncReducer } from '../../standard-actions/';
import {
    IServiceRequestCreateAction,
    IServiceRequestCreateSuccessAction,
    IServiceRequestCreateErrorAction
} from '../actions/create-request';
import { IServiceRequestsState } from '../state';
import { initialState } from '@telstra-connect/service-requests/state/initial-state';

export type RequestsAction
    = IServiceRequestCreateAction
    | IServiceRequestCreateSuccessAction
    | IServiceRequestCreateErrorAction;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const init = (state: IServiceRequestsState, action: RequestsAction) => ({
    ...state,
    createServiceRequest: initialState.createServiceRequest
});

const success = (state: IServiceRequestsState, action: RequestsAction) => ({
    ...state,
    createServiceRequest: {
        data: (action as IServiceRequestCreateSuccessAction).data,
        status: action.status,
        requestActionType: (action as IServiceRequestCreateSuccessAction).requestActionType
    }
});

const failure = (state: IServiceRequestsState, action: RequestsAction) => ({
    ...state,
    createServiceRequest: {
        status: action.status,
        error: (action as IServiceRequestCreateErrorAction).error,
        requestActionType: (action as IServiceRequestCreateErrorAction).requestActionType
    }
});

export const createServiceRequestReducer = createAsyncReducer(initialState, init, success, failure);
